import { Emitter } from "pixi-particles";
import Entity from "./Entity";
import { json } from "p3";

export default class Decal extends Entity {
    /**
     * @param {PIXI.Texture} texture
     */
    constructor(texture) {
        super();

        this._texture = texture;
        this._fx = null;

        this.zSort = true;
    }

    init() {
        super.init();

        this.addViewWithTexture(this._texture)
    }

    destroy() {
        super.destroy();
    }

    update() {
        this._fx && this._fx.update(window.dt);

        super.update();
    }

    emitFx(textures = [], data) {
        this._fx = this._createFx(textures, data);
    }

    _createFx(textures = [], data) {
        const emitter = new Emitter(this, textures, json(data));
        emitter.autoUpdate = false;
        emitter.updateSpawnPos(this.width / 2, this.height / 2);
        return emitter;
    }

    /**
     * @returns {PIXI.Sprite}
     */
    get view() {
        return this._view;
    }

    /**
     * @returns {PIXI.Emitter}
     */
    get emitter() {
        return this._fx;
    }
}